// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout__container {
    display: flex;
    align-items: flex-start;
    font-family: Roboto, sans-serif
}
.layout__row--one {
    position: fixed;
    z-index: 20;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    transition-duration: 300ms
}
.layout__row--two {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transition-duration: 300ms
}
main {
    min-height: 100vh;
    --tw-bg-opacity: 1;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 5rem;
    padding-bottom: 1.5rem
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/layout.css"],"names":[],"mappings":"AACI;IAAA,aAAmC;IAAnC,uBAAmC;IAAnC;AAAmC;AAGnC;IAAA,eAAkD;IAAlD,WAAkD;IAAlD,+LAAkD;IAAlD,gFAAkD;IAAlD,oGAAkD;IAAlD,uGAAkD;IAAlD;AAAkD;AAGlD;IAAA,+LAA6B;IAA7B;AAA6B;AAG7B;IAAA,iBAA8C;IAA9C,kBAA8C;IAA9C,4DAA8C;IAA9C,oBAA8C;IAA9C,qBAA8C;IAA9C,iBAA8C;IAA9C;AAA8C","sourcesContent":[".layout__container {\n    @apply flex items-start font-roboto;\n}\n.layout__row--one {\n    @apply fixed z-20 shadow-xl transform duration-300;\n}\n.layout__row--two {\n    @apply transform duration-300;\n}\nmain {\n    @apply pt-20 bg-blue-50 min-h-screen px-6 pb-6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
